import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getBarriosLista = async () => {
    const res = await getData('/barrios/barrios_select');
    return res
}

export const getBarriosPanel = async (searchTerm,searchLoc,page, perPage) => {
   let queryParams = [];
    if (searchTerm) {
        queryParams.push(`barrio_descripcion=${encodeURIComponent(searchTerm || '')}`);
    } 
    if (searchLoc) {
        queryParams.push(`loc_id=${encodeURIComponent(searchLoc || '')}`);
    }
    if (page) {
        queryParams.push(`page=${encodeURIComponent(page || 1)}`);
    }
    if (perPage) {
        queryParams.push(`perPage=${encodeURIComponent(perPage || 10)}`);
    }
    const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
    const res= await getData("/barrios/barrios_localidades", queryString);
    return res
};

export const getBarrioById = async (id) => {
    const res = await getData(`/barrios/${id}`)
    return res
}

export const getXBarrio = async (searchTerm) => {
    return await getData("/barrios", `?loc_descripcion=${searchTerm}`);
};

export const postBarrio = async (body) => {
    const res = await postData('/barrios', body)
    return res
}

export const patchBarrio = async (id, body) => {
    const res = await patchData(`/barrios/${id}`, body)
    return res
}

export const deleteBarrio = async (id) => {
    const res = await deleteData(`/barrios/${id}`)
    return res
}
